import React from "react";
import { Link } from "react-router-dom";

const Logo = ({ className = "" }) => {
  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`}>
      <svg
        width="42"
        height="34"
        viewBox="0 0 64 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0 md:w-[52px] md:h-[42px]"
      >
        <rect x="2" y="2" width="60" height="40" rx="3" stroke="#111" strokeWidth="2.5" fill="white" />
        <circle cx="20" cy="20" r="1.5" fill="#111" />
        <circle cx="28" cy="20" r="1.5" fill="#111" />
        <circle cx="36" cy="20" r="1.5" fill="#111" />
        <path d="M40 28 L48 36 L52 32 L44 24 Z" fill="#111" />
        <path d="M50 34 L56 40 L52 44 L46 38" stroke="#111" strokeWidth="2" fill="none" />
        <line x1="24" y1="46" x2="40" y2="46" stroke="#111" strokeWidth="2" />
        <line x1="32" y1="42" x2="32" y2="46" stroke="#111" strokeWidth="2" />
      </svg>
      <div className="flex flex-col leading-none">
        <span className="text-xl md:text-3xl font-bold tracking-[0.15em] text-neutral-900 font-sans">
          COMPUTHEER
        </span>
        <span className="text-[8px] md:text-[10px] tracking-[0.2em] md:tracking-[0.25em] text-neutral-700 mt-1 font-medium">
          COMPUTER SERVICE EN REPARATIES
        </span>
      </div>
    </Link>
  );
};

export default Logo;
